import React, { useState, useEffect, useCallback } from "react"
import { useQuery, useMutation } from "react-query"
import { useNavigate, Outlet, Navigate } from "react-router-dom"
import jwtDecode from "jwt-decode"
import { api } from "../util/APIConfig"
import { useIdleTimer } from 'react-idle-timer'
import LayoutNav from "./LayoutNav"
import Breadcrumbs from "./Breadcrumbs"
import LayoutAside from "./LayoutAside"
import CustomScript from './CustomScript';
import TuitionFeedbackModal from "./TuitionFeedbackModal"
import CSATFeedbackModal from "./CSATFeedbackModal"
import ESATSpecificationModal from "./ESATSpecificationModal"
import { getProfileImage } from "../API/API"

function Layout() {
  const [logoImage, setLogoImage] = useState("")
  const [activeNav, setActiveNav] = useState(false)
  const [profileImage, setProfileImage] = useState("")

  const [role, setRole] = useState()
  const [impersonating, setImpersonating] = useState(false)
  const [tuitionHours, setTuitionHours] = useState(0)
  const [showFeedbackModal, setShowFeedbackModal] = useState(false)
  const [showCSATFeedbackModal, setShowCSATFeedbackModal] = useState(false)
  const [expired, setExpired] = useState(false)
  const [studentSchool, setStudentSchool] = useState(null)

  const [requiresESATSpecification, setRequiresESATSpecification] = useState(false)

  const [lastSentActiveTime, setLastSentActiveTime] = useState(0);

  const [feedbackType, setFeedbackType] = useState(null);
  const [tutors, setTutors] = useState([]);
  const [toGiveFeedbackForSibling, setToGiveFeedbackForSibling] = useState(false);

  const [showDiagnosticTest, setShowDiagnosticTest] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token")
    if(token){
      const decodedData = jwtDecode(token)
      const role = decodedData.role
      setRole(role)

      if(role == "Student")
      {  
        if (decodedData.Schools) {
          const { Schools: schools } = decodedData;
        
          if (typeof schools === 'string') {
            setStudentSchool(schools)
          } else if (Array.isArray(schools) && schools.length > 0) {
            setStudentSchool(schools[0])
          }
        }
      }

      const impersonator = decodedData.IsImpersonating
      if(impersonator == "true")
      {
        setImpersonating(true)
      }
    }
  }, [])

  const { refetch } = useQuery("profile", getProfileImage, {
    onSuccess: data => {
      const reader = new FileReader()
      reader.readAsDataURL(data.data)
      reader.onloadend = () => setProfileImage(reader.result)
    },
    refetchOnWindowFocus: false,
    enabled: role === "Student" ? true : false
  })

  const { mutate } = useMutation(
    async id =>
      await api("user/school/AuditDashboard/DownLoad?id=" + id, {
        responseType: "blob"
      }),
    {
      onSuccess: data => {
        const reader = new FileReader()
        reader.readAsDataURL(data.data)
        reader.onloadend = () => setLogoImage(reader.result)
      },
      onError: () => setLogoImage("")
    }
  )

  const { data, isSuccess } = useQuery(
    "schoolInfo",
    async () =>
      await api("user/school/AuditDashboard/SchoolLogo", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      }),
    {
      enabled: role === "School Manager" ? true : false,
      refetchOnWindowFocus: false,
      onSuccess: data => {
        if(data.data.data.logoFilePath) {
          mutate(data.data.data.id)
        }
      }
    }
  )

  const { data2, isSuccess2 } = useQuery(
    "userschoolInfo",
    async () =>
      await api("user/school/AuditDashboard/SchoolLogo", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      }),
    {
      enabled: (role === "Student" && studentSchool) ? true : false,
      refetchOnWindowFocus: false,
      onSuccess: data2 => {
        if(data2.data.data.logoFilePath) {
          mutate(data2.data.data.id)
        }
      }
    }
  )

  const sendActiveTimeToBackend = useCallback((timeDiff) => {
    //console.log('Sending incremental time to backend:', timeDiff, 'ms');
      api.post('/user/UpdateUserActiveTime', { activeTimeUpdateMs: timeDiff });
  }, []);

  const { getTotalActiveTime } = useIdleTimer({
    timeout: 1000 * 60,
    debounce: 500,
    onActive: () => {},
    onIdle: () => {},
  });

  useEffect(() => {
    // This interval will run every 60 seconds (example)
    const interval = setInterval(() => {
      const currentTotal = getTotalActiveTime();
      const difference = currentTotal - lastSentActiveTime;

      if (difference > 0) {
        sendActiveTimeToBackend(difference);
        setLastSentActiveTime(currentTotal);
      }
    }, 60000); // 1 minute

    return () => clearInterval(interval);
  }, [getTotalActiveTime, lastSentActiveTime, sendActiveTimeToBackend]);

  useEffect(() => {
    /*const timeInMilliSeconds = 300000

    const interval = setInterval(async () => {
      await api.post("/user/UpdatePortalTime")
    }, timeInMilliSeconds)*/

    const token = localStorage.getItem("token")

    const interceptor = api.interceptors.request.use(
      function (config) {
        if (token) {
          config.headers.Authorization = `Bearer ${token}`
        }
        return config
      },
      function (error) {
        return Promise.reject(error)
      }
    )

    return () => {
      api.interceptors.request.eject(interceptor)
      //role === "Student" && clearInterval(interval)
    }
  }, [])

  /*useEffect(() => {
    if (role === "Student" && !impersonating) {
      const fetchTuitionHours = async () => {
        try {
          const response = await api.get("/User/Student/GetTutoringHours")
          const resp = response.data.data;

          if (resp.is5thHourFeedbackGiven === false && (resp.hoursUsed >= 5 && resp.hoursUsed < 10)) { 
            setTuitionHours(5)
            setShowFeedbackModal(true)
          }

          if (resp.is10thHourFeedbackGiven === false && resp.hoursUsed >= 10) {
            setTuitionHours(10)
            setShowFeedbackModal(true)
          }
        } catch (error) {
          console.error("Error fetching tuition hours:", error)
        }
      }

      const interval = setInterval(fetchTuitionHours, 600000) // 10 minutes

      fetchTuitionHours() // Initial fetch

      return () => clearInterval(interval)
    }
  }, [role, impersonating])*/

  useEffect(() => {
    if (role === "Student" && !impersonating) {
      const fetchCSATStatus = async () => {
        try {
          const response = await api.get("/User/Student/GetCSATStatus")
          const resp = response.data.data;

          //console.log(resp)
          
          if(resp.toGiveFeedback)
          {
            setFeedbackType(resp.feedbackType)
            setTutors(resp.tutors)
            setToGiveFeedbackForSibling(resp.toGiveFeedbackForSibling)
            setShowCSATFeedbackModal(true)
          }
        } catch (error) {
          console.error("Error fetching CSAT status:", error)
        }
      }

      fetchCSATStatus()
    }
  }, [role, impersonating])

  useEffect(() => {
    if (role === "Student" && !impersonating) {
      const fetchExpiry = async () => {
        try {
          const response = await api.get("/User/Student/GetInfo")
          const resp = response.data.data;
          setExpired(resp.isExpired)

        } catch (error) {
          console.error("Error fetching info:", error)
        }
      }

      fetchExpiry()
    }
  }, [role, impersonating])

  useEffect(() => {
    if (role === "Student" && !impersonating) {
      const fetchEsatSpecification = async () => {
        try {
          const response = await api.get("/User/Student/ESATInfo")
          const resp = response.data.data;
          setRequiresESATSpecification(resp)
        } catch (error) {
          console.error("Error fetching info:", error)
        }
      }

      fetchEsatSpecification()
    }
  }, [role, impersonating])

  useEffect(() => {
    if (role === "Student" && !impersonating) {
      const fetchDiagnosticTest = async () => {
        try {
          const response = await api.get("/User/Student/DiagnosticTest")
          const resp = response.data.data;
          setShowDiagnosticTest(resp)
        } catch (error) {
          console.error("Error fetching diagnostic test:", error)
        }
      }

      fetchDiagnosticTest()
    }
  }, [role, impersonating])

  if(showDiagnosticTest) {
    return <Navigate to="/diagnostic-test" />
  }

  // if(expired) {
  //   return <Navigate to="/expired" />
  // }

  return (
    <>
      <CustomScript
        src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.2.1/jquery.min.js"
        onLoad={() => { 
          // console.log('jQ L') 
        }}
      />
      <div className="flex">
        <LayoutAside
          navActive={activeNav}
          setActiveNav={setActiveNav}
          schoolName={isSuccess ? data.data.data.name : "School Name"}
          schoolImage={logoImage}
        />
        <div className="flex-1 overflow-x-hidden">
          <LayoutNav
            setActiveNav={setActiveNav}
            profileImage={profileImage}
          />
          <div onClick={() => setActiveNav(false)} className="mt-[55px] lg:mt-0">
            <Breadcrumbs className="flex lg:hidden" mobileView />
            <Outlet context={[profileImage, refetch]} />
          </div>
        </div>
      </div>
      <TuitionFeedbackModal
        isOpen={showFeedbackModal}
        onClose={() => setShowFeedbackModal(false)}
        tuitionHours={tuitionHours}
      />
      <ESATSpecificationModal 
        isOpen={requiresESATSpecification}
        onClose={() => setRequiresESATSpecification(false)}
      />
      <CSATFeedbackModal
        isOpen={showCSATFeedbackModal}
        onClose={() => setShowCSATFeedbackModal(false)}
        feedbackType={feedbackType}
        tutors={tutors}
        toGiveFeedbackForSibling={toGiveFeedbackForSibling}
      />
    </>
  )
}

export default Layout
